module.exports = __webpack_public_path__ + "img/order-status.7dda715c.png";